export default "__VITE_ASSET__7032f569__"